module.exports = __webpack_public_path__ + "1507046e94a96a70b455b99ffefbed3f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-15.png
// module id = 3071
// module chunks = 0